import {useTranslation} from "react-i18next";
import {css} from "@emotion/react";
import {Container} from "@pg-design/grid";
import {flex, flexDirection, p} from "@pg-design/helpers-css";

import {pgEmployees} from "../../../common/app/constants/pg_employees";
import {flexGap} from "../../../components/css_helpers/flex";
import {Heading} from "../../../components/Heading";
import {SimpleContainer} from "../../../components/layout/SimpleContainer";
import {CustomerSupport} from "../../monitoring/components/CustomerSupport";
import {pageviewAlgolyticsHit} from "../../tracking/algolytics/pageview_hits";
import {usePageview} from "../../tracking/use_pageview";
import {pageviewUserComHit} from "../../tracking/user_com/hit_user_com";
import {ViewType} from "../../tracking/view_type";
import {BdSubscriptionBox} from "../components/BdSubscriptionBox";
import {FLTRSubscriptionBox} from "../components/FLTRSubscriptionBox";
import {MonitoringSubscriptionBox} from "../components/MonitoringSubscriptionBox";

export const Pricing = () => {
    usePageview(() => {
        pageviewAlgolyticsHit({viewType: ViewType.PRICING});
        pageviewUserComHit();
    });
    const {t} = useTranslation();

    return (
        <SimpleContainer>
            <Container as="section">
                <Heading text={t("pricing.title")} />
                <div css={wrapper}>
                    <BdSubscriptionBox />
                    <MonitoringSubscriptionBox />
                    <FLTRSubscriptionBox />
                </div>
                <div id="contact">
                    <CustomerSupport title={t("contact.title")} persons={[pgEmployees.aleksandra_boratynska]} />
                </div>
            </Container>
        </SimpleContainer>
    );
};

const wrapper = css`
    ${flex()};
    ${flexDirection("column")};
    ${flexGap(6)};
    ${p(1)};
`;
